import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { SelectList } from "@common/selectList";
import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function TemplateSelector({
  reportTemplates,
  selectedTemplateId,
  onSelect,
}: Props) {
  const { t } = useTranslation();
  const selectedTemplate = reportTemplates.find(
    (tmpl) => tmpl.uuid === selectedTemplateId,
  );

  return (
    <SelectList
      rootClassName={styles.templateSelector}
      listClassName={styles.listRoot}
    >
      {({ isOpen, select }) => ({
        input: (
          <div className={classNames(styles.input, { [styles.open]: isOpen })}>
            <p>
              {selectedTemplate?.name ||
                t("projectReportSubmission.templateSelectPlaceholder")}
            </p>
            <ToggleArrowIcon className={styles.icon} />
          </div>
        ),
        list: (
          <div className={styles.list}>
            {reportTemplates.map((tmpl) => (
              <div
                key={tmpl.uuid}
                className={classNames(styles.item, {
                  [styles.selected]: tmpl.uuid === selectedTemplateId,
                })}
                onClick={() => select(onSelect(tmpl.uuid))}
              >
                <p>{tmpl.name || tmpl.uuid}</p>
              </div>
            ))}
          </div>
        ),
      })}
    </SelectList>
  );
}

export { TemplateSelector };
